import React from "react";
import { Link } from "react-router-dom";
import CosmicSubpageShell from "@/components/CosmicSubpageShell";

const sections = [
  {
    title: "1. Agreement",
    body: `By using NFG Games (including NFG Crash, Hangman, Fuse, Hunt, and related companion apps and live overlays), you agree to these Game Terms. If you do not agree, do not use the services.

NFG Games are companions for TikTok LIVE entertainment. Virtual points have no cash value and cannot be withdrawn or exchanged for money.`,
  },
  {
    title: "2. Eligibility",
    body: `You must be at least 17 years old to use betting-style or wallet features because they include simulated wagering mechanics tied to a live stream game.

You are responsible for complying with local laws where you use the apps or website.`,
  },
  {
    title: "3. Account & TikTok linking",
    body: `Access to betting and wallet features requires verifying ownership of a TikTok account (for example by posting a command on the host’s live stream). You may not impersonate another person or use accounts you do not control.

We may suspend or revoke access for abuse, fraud, or violations of these terms.`,
  },
  {
    title: "4. Virtual points & entertainment",
    body: `Points, badges, cosmetics, leaderboards, and arcade rewards are virtual entertainment credits. They are not legal tender, securities, or gambling winnings. There is no cash-out.

Competition is for fun among viewers of the live stream and companion app players.`,
  },
  {
    title: "5. In-App Purchases & ads",
    body: `Optional point packs, where offered on iOS, are sold only through Apple In-App Purchase. Prices are shown before you confirm a purchase. Sales follow Apple’s policies except where required by law.

Optional rewarded video ads may grant bonus points. Ad availability is not guaranteed. See the Privacy Policy for how ad partners may process data.`,
  },
  {
    title: "6. Acceptable use",
    body: `You agree not to cheat, exploit bugs, automate play, or interfere with servers; harass other users or post prohibited names or chat content; or reverse engineer the apps or attempt unauthorized access.

We may modify, pause, or discontinue features at any time.`,
  },
  {
    title: "7. Disclaimer",
    body: `The apps, website, and live game services are provided “as is” without warranties of any kind. We do not guarantee uninterrupted service, specific outcomes, or error-free operation.

To the fullest extent permitted by law, we are not liable for indirect or consequential damages arising from use of NFG Games.`,
  },
  {
    title: "8. Changes",
    body: `We may update these terms. Material changes will be reflected by updating the “Last updated” date. Continued use after changes means you accept the revised terms.`,
  },
];

export default function GameTermsPage() {
  return (
    <CosmicSubpageShell testId="game-terms-page-shell">
      <div className="mx-auto max-w-4xl px-6 md:px-10 space-y-4 mt-8">
        <article className="rounded-2xl border border-purple-400/25 bg-black/60 p-6 md:p-8" data-testid="game-terms-header">
          <h1 className="font-display font-black uppercase text-3xl md:text-4xl tracking-tight">Game Terms</h1>
          <p className="mt-3 text-zinc-300 text-sm">Last updated: 20 May 2026</p>
        </article>

        {sections.map((section) => (
          <article
            key={section.title}
            className="rounded-2xl border border-purple-400/20 bg-black/55 p-6"
          >
            <h2 className="font-display font-black uppercase text-2xl tracking-tight">{section.title}</h2>
            <p className="mt-4 text-zinc-300 text-sm whitespace-pre-line">{section.body}</p>
          </article>
        ))}

        <article className="rounded-2xl border border-purple-400/20 bg-black/55 p-6" data-testid="game-terms-contact">
          <h2 className="font-display font-black uppercase text-2xl tracking-tight">Contact</h2>
          <p className="mt-4 text-zinc-300 text-sm">
            Questions:{" "}
            <a className="text-purple-300" href="mailto:legal@y666suf.com">
              legal@y666suf.com
            </a>
            {" · "}
            <Link className="text-purple-300" to="/privacy">
              Privacy Policy
            </Link>
            {" · "}
            <Link className="text-purple-300" to="/legal">
              Legal &amp; Compliance
            </Link>
          </p>
        </article>
      </div>
    </CosmicSubpageShell>
  );
}
